import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {EscolaService} from '../../services/escola.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-cursos-pagina-listagem',
  templateUrl: './listagem-cursos.component.html',
  styleUrls: ['../userpanel.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [EscolaService]
})
export class ListagemCursosPaginaComponent implements OnInit {

  @Output() trailLength: EventEmitter<any> = new EventEmitter<any>();

  public arrayTrilhaActiveList = [];
  public arrayTrilhaDoneList = [];
  public arrayTrilhaStart = [];
  public loaderActivated = false;
  public baseUrl = environment.apiUrl;

  constructor(private _escolaService: EscolaService) {
    this.loaderActivated = true;
  }

  ngOnInit() {
    this.getTrail();
    console.log(this.arrayTrilhaStart)
  }

  getTrail(): void {
    this.arrayTrilhaActiveList = [];
    this.arrayTrilhaDoneList = [];
    this.arrayTrilhaStart = [];

    this._escolaService.getTrilha()
      .subscribe(result => {
        if (result) {
          const trails = result.data.filter((item) => {
            return item.status === 1;
          });
          for(const trilha of trails) {
            if(trilha.porcentagem > 0) {
              this.arrayTrilhaStart.push(trilha);
            }
          }
          this.loaderActivated = false;
        }
        this.trailLength.emit(this.arrayTrilhaStart)
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/listagem-cursos-pagina/listagem-cursos.component.ts